// Load Styles
import 'swiper/css/bundle';
import 'select2/dist/css/select2.min.css';
import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.min.css';
import "@fancyapps/ui/dist/fancybox.css";
import '../scss/main.scss';

// Load Bootstrap init
import {initBootstrap} from "./bootstrap.js";
import Swiper from "swiper/bundle";
import "select2";
import {Fancybox} from "@fancyapps/ui";

import {Modal, Tooltip} from 'bootstrap';

// Loading bootstrap with optional features
initBootstrap({
  tooltip: true,
  popover: true,
  toasts: false
});

const scrollTo = document.getElementsByClassName('scroll-to')[0];
if (document.body.contains(scrollTo)) {
  const triggers = [].slice.call(scrollTo.querySelectorAll('li'));
  triggers.map(element => {
    element.addEventListener('click', function (event) {
      const target = document.querySelector(this.dataset.scrollto);
      target.scrollIntoView();
    });
  })
}

document.addEventListener('DOMContentLoaded', function () {

  const myModalEl = document.querySelector('#loginModal');
  if (myModalEl) {
    myModalEl.addEventListener('show.bs.modal', event => {
      let link = event.relatedTarget;
      if (link.dataset.reload) {
        document.querySelector("body").dataset.reload = 'true';
      }
    });
  }

  setupTooltip();

  document.querySelectorAll('.navbar .nav-item.dropdown').forEach(function (everyitem) {
    everyitem.addEventListener('mouseover', function (e) {
      let el_link = this.querySelector('a[data-bs-toggle]');

      if (el_link !== null) {
        let nextEl = el_link.nextElementSibling;
        el_link.classList.add('show');
        nextEl.classList.add('show');
        nextEl.dataset.bsPopper = 'static';
      }
    });

    everyitem.addEventListener('mouseleave', function (e) {
      let el_link = this.querySelector('a[data-bs-toggle]');

      if (el_link !== null) {
        let nextEl = el_link.nextElementSibling;
        el_link.classList.remove('show');
        nextEl.classList.remove('show');
        nextEl.removeAttribute('data-bs-popper');
      }
    });

  })
})

const clipboard = document.getElementById('copy-to-clipboard');
if (document.body.contains(clipboard)) {
  clipboard.addEventListener('click', function (event) {
    navigator.clipboard.writeText(window.location.href).then(
      () => {
        /* clipboard successfully set */
      },
      () => {
        /* clipboard write failed */
      }
    );
  });
}

const submitSearchModalForm = document.getElementById('submitSearchModalForm');
if (document.body.contains(submitSearchModalForm)) {
  submitSearchModalForm.addEventListener('click', (e) => {
    const searchModalForm = document.getElementById('searchModalForm');
    searchModalForm.submit();
  });
}

const mobileSearchInput = document.getElementById('mobile-search');
const mobileSearchHiddenInput = document.getElementById('mobile-search-hidden');
if (document.body.contains(mobileSearchInput) && document.body.contains(mobileSearchHiddenInput)) {
  mobileSearchInput.addEventListener('input', function (event) {
    console.log(this.value);
    mobileSearchHiddenInput.value = this.value;
  });
}

const tabs = document.getElementsByClassName('tabs')[0];
if (document.body.contains(tabs)) {
  const navtabs = [...tabs.querySelectorAll('.nav-tabs .nav-link')];
  const navtabsReverse = [...tabs.querySelectorAll('.nav-tabs .nav-link')].reverse();

  navtabs.forEach((singleTab) => {
    singleTab.style.display = 'none';
  });

  const loopEnd = navtabs.length >= 4 ? 4 : navtabs.length;
  for (let i = 0; i < loopEnd; i++) {
    navtabs[i].style.display = 'block';
  }

  const tabPagePev = document.getElementsByClassName('tab-prev')[0];
  const tabPageNext = document.getElementsByClassName('tab-next')[0];

  function fadeOut(el) {
    el.style.opacity = 1;

    (function fade() {
      if ((el.style.opacity -= .1) < 0) {
        el.style.display = "none";
      } else {
        requestAnimationFrame(fade);
      }
    })();
  }

  function fadeIn(el, display) {
    el.style.opacity = 0;
    el.style.display = display || "block";

    (function fade() {
      var val = parseFloat(el.style.opacity);
      if (!((val += .1) > 1)) {
        el.style.opacity = val;
        requestAnimationFrame(fade);
      }
    })();
  }

  tabPagePev.addEventListener('click', function () {
    let currentPos = -1;
    let lastPos = -1;
    navtabsReverse.forEach((tab, index) => {
      if (tab.style.display === 'block') {
        currentPos = index;
        lastPos = index + 4;

        if (lastPos < navtabs.length) {
          fadeOut(tab);
        }
      }
      if (currentPos >= 0 && lastPos >= 0 && index <= lastPos && tab.style.display !== 'block') {
        fadeIn(tab, 'block');
      }

    });
  });

  tabPageNext.addEventListener('click', function () {
    let currentPos = -1;
    let lastPos = -1;
    navtabs.forEach((tab, index) => {
      if (tab.style.display === 'block') {
        currentPos = index;
        lastPos = index + 4;

        if (lastPos < navtabs.length) {
          fadeOut(tab);
        }
      }
      if (currentPos >= 0 && lastPos >= 0 && index <= lastPos && tab.style.display !== 'block') {
        fadeIn(tab, 'block');
      }
    });
  });
}

const config = {
  slidesPerView: "auto",
  spaceBetween: 20,
  grabCursor: true,
  slidesOffsetBefore: 20,
  slidesOffsetAfter: 20,
  breakpoints: {
    744: {
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0
    }
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  }
}

let positions = new Swiper('.position-slider', config);
let coworkers = new Swiper('.coworker-slider', config);

let percentTime;
let tick;
let progressBar = document.querySelector('.swiper-gallery-progress');

const updateSwiperProgressBar = (bar, delay) => {
  function startProgresbar() {
    resetProgressBar();
    tick = setInterval(progress, 50);
  }

  function progress() {
    let timeLeft = gallery.autoplay.timeLeft;
    if (gallery.autoplay.running && !gallery.autoplay.paused) {
      percentTime = Math.min(100, Math.max(0, 100 - Math.round(timeLeft / delay * 100)));
      bar.style.width = percentTime + '%';

      if (percentTime > 100) {
        resetProgressBar();
      }
    }

    if (gallery.autoplay.paused) {
      percentTime = 0;
      bar.style.width = 0;
    }
  }

  function resetProgressBar() {
    percentTime = 0;
    bar.style.width = 0;
    clearInterval(tick);
  }

  startProgresbar();
};

let gallery = new Swiper('.gallery-slider', {
  loop: true,
  watchSlidesProgress: true,
  effect: 'fade',
  centeredSlides: true,
  fadeEffect: {
    crossFade: true
  },
  autoplay: {
    delay: 4000
  },
  on: {
    slideChange() {
      let swiper = this;
      let slideDelay = swiper.params.autoplay.delay;
      updateSwiperProgressBar(progressBar, slideDelay);
    }
  }
});

document.addEventListener('click', function (event) {
  // If the clicked element doesn't have the right selector, bail
  if (!event.target.matches('.gallery-opener-button')) {
    return;
  }

  // Don't follow the link
  event.preventDefault();

  let slides = document.querySelectorAll('#gallery-wrapper .swiper-slide');
  let slidesArray = Array.prototype.slice.call(slides, 0);
  slidesArray.sort((a, b) => {
    let indexA = a.dataset.swiperSlideIndex;
    let indexB = b.dataset.swiperSlideIndex;

    if (indexA > indexB) {
      return 1;
    }
    if (indexA < indexB) {
      return -1;
    }

    return 0;
  });

  let gallery = [];
  let index = 0;
  for (let i = 0; i < slidesArray.length; i++) {
    const slide = slidesArray[i];
    if (slide.classList.contains('swiper-slide-active')) {
      index = i;
    }

    gallery.push({
      src: slide.children[0].getAttribute('src'),
      type: 'image'
    });
  }

  Fancybox.show(gallery, {startIndex: index});

}, false);

function setupTooltip()
{
  const myTooltipEls = document.getElementsByClassName('info-trigger');

  const elements = Array.prototype.filter.call(myTooltipEls,
    element => {
      const tooltip = Tooltip.getOrCreateInstance(element);
      element.addEventListener('mouseenter', e => {
        tooltip.show();
        const tool = document.getElementsByClassName('tooltip')[0];
        tool.addEventListener('mouseleave', e => {
          tooltip.hide();
        });
      });

      element.addEventListener('mouseleave', e => {
        setTimeout(() => {
          const hovered = document.querySelector(".tooltip:hover");

          if (!hovered) {
            tooltip.hide();
          }
        }, 200);
      });
    });
}
function setupSelect2() {
  if ($('#searchModal').length) {
    $('.search-modal-dropdown').select2({
      placeholder: $('html').attr('lang') === 'hu' ? 'Kérlek válassz' : 'Please choose',
      theme: "bootstrap-5",
      dropdownParent: $('#searchModal'),
      minimumResultsForSearch: Infinity,
      closeOnSelect: false
    });
  }

  if ($('#filterModal').length) {
    $('.search-modal-dropdown').select2({
      placeholder: $('html').attr('lang') === 'hu' ? 'Kérlek válassz' : 'Please choose',
      theme: "bootstrap-5",
      dropdownParent: $('#filterModal'),
      minimumResultsForSearch: Infinity,
      closeOnSelect: false
    });
  }

  $('.search-modal-dropdown').on('select2:opening select2:closing', function (event) {
    let $searchfield = $(this).parent().find('.select2-search__field');
    $searchfield.prop('disabled', true);
  });

  if ($('#searchModal').length || $('#filterModal').length) {
    $('.search-modal-dropdown').on('select2:opening select2:closing', function (event) {
      let $searchfield = $(this).parent().find('.select2-search__field');
      $searchfield.prop('disabled', true);
    });
  }

  if ($('.positions-content aside').length) {
    $('.aside-filter-dropdown').select2({
      placeholder: $('html').attr('lang') === 'hu' ? 'Kérlek válassz' : 'Please choose',
      theme: "bootstrap-5",
      dropdownParent: $('.positions-content aside'),
      minimumResultsForSearch: Infinity,
      closeOnSelect: false,
      width: 'auto'
    });

    $('.aside-filter-dropdown').on('select2:opening select2:closing', function (event) {
      let $searchfield = $(this).parent().find('.select2-search__field');
      $searchfield.prop('disabled', true);
    });
  }

  $('.sort-dropdown').select2({
    theme: "bootstrap-5",
    minimumResultsForSearch: Infinity,
    closeOnSelect: false,
    width: '196px'
  });
}

$(document).ready(function () {
  setupSelect2();

  $('.main').on('click', '.label-toggle', e => {
    e.preventDefault();
    let $list = $('#joblist');
    let $this = $(e.currentTarget);
    let $li = $this.closest('li');

    $.ajax({
      url: $this.attr('href'),
      method: 'get',
      data: {state: 'active' === $li.attr('class') ? 'inactive' : 'active'}
    })
    .done(function (data) {
      data = $.parseJSON(data);
      if ('url' in data) {
        history.replaceState([], '', data.url);
      }
      if ('carreer' in data) {
        $('#carrer-path-modal-body').html(data.carreer);
      }
      $list.html(data.list);
      $('#filter-side-form-holder').html(data.filter);
      $('#filter-modal-form-holder').html(data.modal);
      setupSelect2();
      setupTooltip();
    });
  });

  $('.main').on('click', '.remove-filter', e => {
    e.preventDefault();
    let $list = $('#joblist');
    let $this = $(e.currentTarget);

    $('html, body').animate({scrollTop: $list.offset().top}, _ => {
      $list.html('<img class="loading" src="/images/loading.gif" />');
    });

    $.ajax({
      url: $this.attr('href'),
      method: 'get'
    })
    .done(function (data) {
      data = $.parseJSON(data);
      if ('url' in data) {
        history.replaceState([], '', data.url);
      }
      if ('carreer' in data) {
        $('#carrer-path-modal-body').html(data.carreer);
      }

      $list.html(data.list);
      $('#filter-side-form-holder').html(data.filter);
      $('#filter-modal-form-holder').html(data.modal);
      setupSelect2();
      setupTooltip();
    });
  });

  $('.positions-content aside').on('click', '.side-filter-submit', e => {
    e.preventDefault();
    let $form = $('.positions-content aside form');
    let formData = new FormData($form[0]);
    let $list = $('#joblist');

    $('html, body').animate({scrollTop: $list.offset().top}, _ => {
      $list.html('<img class="loading" src="/images/loading.gif" />');
    });

    $.ajax({
      url: $form.attr('action'),
      method: 'POST',
      data: formData,
      processData: false,
      contentType: false
    })
    .done(function (data) {
      data = $.parseJSON(data);
      if ('url' in data) {
        history.replaceState([], '', data.url);
      }
      if ('carreer' in data) {
        $('#carrer-path-modal-body').html(data.carreer);
      }

      $list.html(data.list);
      $('#filter-side-form-holder').html(data.filter);
      $('#filter-modal-form-holder').html(data.modal);
      setupSelect2();
      setupTooltip();
    });
  });

  $('.main').on('click', '.search-page-link', e => {
    e.preventDefault();
    let $list = $('#joblist');
    let $this = $(e.currentTarget);

    $('html, body').animate({scrollTop: $list.offset().top}, _ => {
      $list.html('<img class="loading" src="/images/loading.gif" />');
    });

    $.ajax({
      url: $this.attr('href'),
      method: 'get'
    })
    .done(function (data) {
      data = $.parseJSON(data);

      if ('url' in data) {
        history.replaceState([], '', data.url);
      }
      if ('carreer' in data) {
        $('#carrer-path-modal-body').html(data.carreer);
      }

      $list.html(data.list);
    });
  });

  $(document).on('click', '.carreer-path-trigger', e => {
    e.preventDefault();
    const myTooltipEls = document.getElementsByClassName('info-trigger');

    const elements = Array.prototype.filter.call(myTooltipEls,
      element => {
        const tooltip = Tooltip.getOrCreateInstance(element);
        tooltip.hide();
      });
    let modalInst = Modal.getOrCreateInstance(document.getElementById('carrierPathModal'));
    modalInst.show();
  })

  $('#filterModal').on('click', '.search-modal-submit', e => {
    e.preventDefault();
    let $form = $('#filterModal form');
    let formData = new FormData($form[0]);
    let $list = $('#joblist');
    let modalInst = Modal.getInstance(document.getElementById('filterModal'));

    modalInst.hide();

    $('html, body').animate({scrollTop: $list.offset().top}, _ => {
      $list.html('<img class="loading" src="/images/loading.gif" />');
    });

    $.ajax({
      url: $form.attr('action'),
      method: 'POST',
      data: formData,
      processData: false,
      contentType: false
    })
    .done(function (data) {
      data = $.parseJSON(data);
      if ('url' in data) {
        history.replaceState([], '', data.url);
      }
      if ('carreer' in data) {
        $('#carrer-path-modal-body').html(data.carreer);
      }

      $list.html(data.list);
      $('#filter-side-form-holder').html(data.filter);
      $('#filter-modal-form-holder').html(data.modal);
      setupSelect2();
      setupTooltip();
    });
  });
});
